import React, { useEffect, useState } from 'react';
import { useAnnouncements } from '../hooks/useAnnouncements';
import { toast } from 'react-toastify';

export function AnnouncementListTab() {
  const { list, deleteAnnouncement, loading } = useAnnouncements();
  const [announcements, setAnnouncements] = useState([]);
  const [filterCompanyId, setFilterCompanyId] = useState('');
  const [deleting, setDeleting] = useState(null);

  useEffect(() => {
    loadAnnouncements();
  }, [filterCompanyId]);

  const loadAnnouncements = async () => {
    try {
      const data = await list(filterCompanyId || null);
      setAnnouncements(data);
    } catch (error) {
      toast.error(`Erro ao carregar informativos: ${error.message}`);
    }
  };

  const handleDelete = async (announcement) => {
    if (!window.confirm(`Tem certeza que deseja deletar "${announcement.title}"?`)) {
      return;
    }

    try {
      setDeleting(announcement.id);
      await deleteAnnouncement(announcement.id, announcement.databaseId);
      setAnnouncements(prev => prev.filter(a => a.id !== announcement.id));
      toast.success('Informativo deletado com sucesso!');
    } catch (error) {
      toast.error(`Erro ao deletar: ${error.message}`);
    } finally {
      setDeleting(null);
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex gap-4 items-end">
        <div className="flex-1">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Filtrar por ID da Empresa
          </label>
          <input
            type="number"
            value={filterCompanyId}
            onChange={(e) => setFilterCompanyId(e.target.value)}
            placeholder="Deixe em branco para todos"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <button
          onClick={loadAnnouncements}
          disabled={loading}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400"
        >
          {loading ? 'Carregando...' : 'Carregar'}
        </button>
      </div>

      {announcements.length === 0 ? (
        <div className="text-center py-8 text-gray-500">
          Nenhum informativo encontrado
        </div>
      ) : (
        <div className="space-y-3">
          {announcements.map((announcement) => (
            <div
              key={`${announcement.databaseId}-${announcement.id}`}
              className="border border-gray-200 rounded-lg p-4 hover:shadow-lg transition"
            >
              <div className="flex justify-between items-start gap-4">
                <div className="flex-1">
                  <h3 className="text-lg font-semibold text-gray-900">
                    {announcement.title}
                  </h3>
                  <p className="text-sm text-gray-600 mt-1">
                    {announcement.text ? announcement.text.substring(0, 150) : 'Sem descrição'}
                    {announcement.text && announcement.text.length > 150 ? '...' : ''}
                  </p>
                  <div className="flex gap-4 mt-2 text-sm text-gray-500">
                    <span>DB: <strong>{announcement.database}</strong></span>
                    <span>Empresa: <strong>{announcement.companyId}</strong></span>
                    <span>Prioridade: <strong>{announcement.priority}</strong></span>
                    <span>Status: <strong>{announcement.status ? 'Ativo' : 'Inativo'}</strong></span>
                  </div>
                  <div className="text-xs text-gray-400 mt-2">
                    {new Date(announcement.createdAt).toLocaleString('pt-BR')}
                  </div>

                  {announcement.mediaFiles && announcement.mediaFiles.length > 0 && (
                    <div className="mt-3 space-y-2">
                      <p className="text-xs font-semibold text-gray-600">Mídias:</p>
                      {announcement.mediaFiles.map((media, idx) => (
                        <div key={idx} className="text-xs text-gray-600">
                          <a href={media.mediaPath} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                            📎 {media.mediaName}
                          </a>
                          {media.caption && <p className="text-gray-500">"{media.caption}"</p>}
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <button
                  onClick={() => handleDelete(announcement)}
                  disabled={deleting === announcement.id}
                  className="px-3 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:bg-gray-400 text-sm whitespace-nowrap"
                >
                  {deleting === announcement.id ? 'Deletando...' : 'Deletar'}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
